<template>
    <div id="how-it-works-business">
        <!--=====================================-->
        <!--=      About  Quality Area Start    =-->
        <!--=====================================-->
        <section class="section bg-color-light-gray mb--50 sunflower-supplier">
            <div class="container">
                <div class="section-heading heading-light-left mb--100">
                    <span class="subtitle primary">¿Cómo funciona?</span>
                    <h2 class="font-weight-100">Pasos a <strong>seguir</strong>.</h2>
                </div>
                <div class="row">
                    <div class="col-lg-3">
                        <div class="about-quality active">
                            <div class="bullet cursor-icon" :style="`background-image: url(${img1});`"></div>
                            <h5 class="title black">1. Solicita</h5>
                            <p class="black">
                                Comienza tu solicitud de crédito <a href="#" class="rg-a">aquí</a>.
                            </p>
                        </div>
                    </div>
                    <div class="col-lg-3">
                        <div class="about-quality">
                            <div class="bullet" :style="`background-image: url(${img3});`"></div>
                            <h5 class="title black">2. Fondea</h5>
                            <p class="black">
                                Fondea tu crédito y firma los documentos correspondientes.
                            </p>
                        </div>
                    </div>
                    <div class="col-lg-3">
                        <div class="about-quality">
                            <div class="bullet" :style="`background-image: url(${img2});`"></div>
                            <h5 class="title black">3. Utiliza</h5>
                            <p class="black">
                                Aprovecha los beneficios para ti y tu familia.
                            </p>
                        </div>
                    </div>
                    <div class="col-lg-3">
                        <div class="about-quality">
                            <div class="bullet card-icon" :style="`background-image: url(${img4});`"></div>
                            <h5 class="title black">4. Paga</h5>
                            <p class="black">
                                Cubre tus mensualidades y retribuye a los cientos de personas que confiaron en ti.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: "HowItWorks",
    components: {
    },
    data() {
        return {
            img1: "https://cdn.redgirasol.com/nuevo_portal/icons/cursor-icon.png",
            img2: "https://cdn.redgirasol.com/nuevo_portal/icons/sunflower-icon.png",
            img3: "https://cdn.redgirasol.com/nuevo_portal/icons/coin-icon.png",
            img4: "https://cdn.redgirasol.com/nuevo_portal/icons/icon-card.png",
        }
    }
}

</script>

<style scoped>

#how-it-works-business {
    /* position: relative; */
    /* top: -18rem; */
    z-index: 0;
    /* height: 25rem; */
}

@media only screen and (max-width: 575px) {
    #how-it-works-business {
        position: inherit;
        height: 100%;
    }
}

@media only screen and (max-width: 991px) {
    #how-it-works-business {
        position: inherit;
        height: 100%;
    }
}

.p-width {
    width: 15rem !important;
}

.bullet {
    background-repeat: no-repeat;
    background-size: 4.5rem;
    /* background-position-x: 1rem; */
}

.bullet.cursor-icon {
    background-size: 3.5rem !important;
    background-position-x: 1rem !important;
}

.bullet.card-icon {
    border-radius: 0 !important;
    background-position-y: center;
    background-position-x: center;
}

.sunflower-supplier {
    background-position: center;
}
</style>